﻿import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IExport, ITag } from "@models/entity-models";
import { eExportType } from "@models/enums";

@Kbo(CToken.Export)
export class Export extends KbObject implements IExport {

    constructor(kom: KbObjectManager) {
        super(kom);
        this.postToCloud = true;
        this.enabled = true;
    }
    
    public type: string;
    public targetDirectory: string;
    public targetFilename: string;
    public enabled: boolean;
    public postToCloud: boolean;
    public resultFilePath: string;
    public pass: string;

    private _tags: ITag[];
    @Enumerable()
    public get tags(): ITag[] {
        if (!this._tags) this._tags = [];
        return this._tags;
    }
    public set tags(val) {
        this._tags = val;
    }

    public static ImageTypes(): string[] {
        return [eExportType.bmp, eExportType.gif, eExportType.jpg, eExportType.png, eExportType.tiff];
    }
}
